exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--aqua:#a0f9d3;--light_purple:#a8a4fc;--azure:#6ceeff;--dark-grey:#333;--light-grey:#f7f7f7;--desktop-padding:72px;--mobile-padding:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/vue/css/variables.css
// module id = 14
// module chunks = 0